// Lib
import { createProvider } from 'react-redux';

// Constants
import { MEASUREMENTS_STORE_NAME } from './measurementsConstants';

export default createProvider(MEASUREMENTS_STORE_NAME);
